import Cable from 'actioncable'

import store from './store/index'
import {actions} from './modules/chat'
import * as notificationActions from './modules/notificationActionCreators'
import config from './modules/config'
import auth from './modules/auth'

const cable = Cable.createConsumer(config.socket)

const connected = {
  chatroom: false,
  notification: false,
  chatroom_ids: []
}

let findmeChatroomChannel

export const subscribeChatroomChannel = (chatroomIds) => {
  const data = {
    message: {
      access_token: auth.getAccessToken(),
      chatroom_ids: chatroomIds,
    }
  }
  const callback = () => findmeChatroomChannel.listen(data)
  waitForConnection(callback, 'chatroom')
}

export const subscribeNotificationChannel = () => {
  const data = {
    message: {
      access_token: auth.getAccessToken(),
    }
  }
  const listenCallback = () => findmeNotificationChannel.listen(data)
  waitForConnection(listenCallback, 'notification')
}

const createFindmeChatroomChannel = () => {
  if (!findmeChatroomChannel) {
    findmeChatroomChannel = cable.subscriptions.create({
      channel: 'FindmeChatroomChannel'
    }, {
      connected: () => {
        connected.chatroom = true
      },
      received: (data) => {
        store.dispatch(actions.onReceivedFromChatroomChannel(data))
      },
      rejected: () => {
      },
      listen: function (data) {
        let connectedRoom = false
        data.message.chatroom_ids.forEach(chatroom_id => {
          if (connected.chatroom_ids.includes(chatroom_id)) {
            connectedRoom = true
          }
        });
        if (!connectedRoom) {
          this.perform('listen', data)
        }
        connected.chatroom_ids = Array.from(new Set(connected.chatroom_ids.concat(data.message.chatroom_ids)))
      },
      speak: function (data) {
        this.perform('speak', data)
      },
      updateLastReadMessageId: function (data) {
        this.perform('update_last_read_message', data)
      },
    })
  }
}

if (!findmeChatroomChannel) {
  createFindmeChatroomChannel()
}

export const findmeNotificationChannel = cable.subscriptions.create({
  channel: 'FindmeNotificationChannel'
}, {
  connected: () => {
    connected.notification = true
  },
  received: (data) => {
    store.dispatch(notificationActions.onReceiveFromNotificationChannel(data))
  },
  rejected: () => {},
  listen: function(data) {
    this.perform('listen', data)
  }
})

const waitForConnection = (callback, channel) => {
  if (connected[channel]) {
    callback()
  } else {
    setTimeout(() => {
      waitForConnection(callback, channel)
    }, 500)
  }
}

export { findmeChatroomChannel }



// WEBPACK FOOTER //
// ./src/websocket.js